import React, { Component } from 'react'
import Activity from "framework/containers/Activity"

//redux
import { connect } from 'react-redux'
import { mapStateToProps, mapDispatchToProps } from 'framework/utils/Redux'

class ShopItemActivity extends Component {

	constructor(props){
		super(props)
		this.RenderedComponent = import("app/components/Shop/ShopItem/ShopItemBrowser")
	}

	render() {
		return (
			<Activity 
				name="ShopItem"
				RenderedComponent={this.RenderedComponent}
				context="ShopItem"
			/>
		)
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(ShopItemActivity)
